import DomManipulate from './DomManipulate';
import FormValidator from './validator'
export default class validateForm {
    /**
     * constructor
     * @param {String} selector The selector to use for forms to be validated
     * @param {Object} options  User settings [optional]
     */
    constructor(formSelector, settings) {
      this.settings = this.extend({}, settings || {});
      this.formSelector = formSelector;
    }

    init() {
      $().ready(() => {
        this.load();
      });
    }

    //INITIALIZE
  load() {
    console.log('validateForm -- load');
    const that = this;
    const userLang = document.documentElement.lang;
    const validatorClasses = {
      item: 'form-group',
      alert: 'invalid-feedback',
      bad: 'is-invalid'
    };

    const validatorTexts = (userLang === "fr") ? {
      invalid: 'Valeur invalide.',
      short: 'Valeur trop courte.',
      long: 'Valeur trop longue.',
      checked: 'Vous devez cochez cette option.',
      empty: 'Une valeur est requise.',
      select: 'Une valeur est requise.',
      number_min: 'Valeur trop petite.',
      number_max: 'Valeur trop grande.',
      url: 'URL invalide.',
      number: 'Pas un nombre.',
      email: 'Adresse couriel invalide.',
      email_repeat: 'Les couriels ne correspondent pas.',
      date: 'Date invalide.',
      time: 'Temps invalide.',
      password_repeat: 'Les mots de passe ne correspondent pas.',
      no_match: 'les valeurs ne correspondent pas.',
      complete: 'Entrée incomplète.',
      fileExt: 'Format de fichier invalide. Formats supportés : \'.docx\', \'.doc\', \'.pdf\', \'.jpg\', \'.png\'',
      fileSize: 'La taille du fichier doit être inférieure à 5 Mo.'
    } : {
      invalid: 'Invalid value.',
      short: 'Input is too short.',
      long: 'Input is too long.',
      checked: 'Must be checked.',
      empty: 'A value is required.',
      select: 'A value is required.',
      number_min: 'Too low.',
      number_max: 'Too high.',
      url: 'Invalid URL.',
      number: 'Not a number.',
      email: 'Email address invalid.',
      email_repeat: 'Emails do not match.',
      date: 'Invalid date.',
      time: 'Invalid time.',
      password_repeat: 'Passwords do not match.',
      no_match: 'No match.',
      complete: 'Input is not complete.',
      fileExt: 'Invalid file format. Supported formats: \'.docx\', \'.doc\', \'.pdf\', \'.jpg\', \'.png\'',
      fileSize: 'File size should be less than 5 MB.'
    };

    const registerForm = document.querySelector(that.formSelector);
    const validator = new FormValidator({ "events": ['change', 'blur', 'paste'], "classes": validatorClasses, "texts": validatorTexts }, registerForm);

    // on form "submit" event
    registerForm.addEventListener('submit', function(event) {

      event.preventDefault();
      event.stopPropagation();

      let isValid = true;

      let checkboxes = document.querySelectorAll("input[name='isretail'], input[name='isexpeditor'], input[name='isdistributor'], input[name='ismanufacturer']");
      let isChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
      let errorContainer = document.querySelector(".businesstype-error");

      if(errorContainer) {
        errorContainer.innerHTML = validatorTexts.empty;
        if (!isChecked) {
          errorContainer.classList.remove('hidden');
          isValid = false;
        } else {
          errorContainer.classList.add('hidden');
          isValid = true;
        }
      }

      const validatorResult = validator.checkAll(this);
      if (!validatorResult.valid || !isValid) {
        if ($(that.formSelector).hasClass('js-scroll-on-error')) {
          let $scrollToEl = $(that.formSelector + ' ' + '.invalid-feedback:visible:first').parent(".form-group");
          let $fortinHeader = $(".fortin-header");
          if ($scrollToEl.length) {
            $('html, body').animate({
              scrollTop: $scrollToEl.offset().top - $fortinHeader.height()
            }, 1000);
          }
        }
        return false;
      }

      let data;
      let action = $(that.formSelector).attr('action');
      if ($(that.formSelector).find("input[name='g-recaptcha-response']").length > 0) {
        grecaptcha.ready(function() {
          grecaptcha.execute('6Le1XMEZAAAAAH4ScUO9vwt5Vmeyg6p3hM1qYQUt', { action: 'submit' }).then(function(token) {
            $(that.formSelector).find("input[name='g-recaptcha-response']").val(token);
            data = new FormData(document.querySelector(that.formSelector));
            that.settings.afterValidationSuccess.postFormAjax(data, action);
          });
        });
      } else {
        data = new FormData(document.querySelector(that.formSelector));
        that.settings.afterValidationSuccess.postFormAjax(data, action);
      }

    }, false);
  }

  /**
     * MDN polyfill for Object.assign
     */
         extend( target, varArgs ) {
          if( !target )
              throw new TypeError('Cannot convert undefined or null to object');

          var to = Object(target),
              nextKey, nextSource, index;

          for( index = 1; index < arguments.length; index++ ){
              nextSource = arguments[index];

              if( nextSource != null ) // Skip over if undefined or null
                  for( nextKey in nextSource )
                      // Avoid bugs when hasOwnProperty is shadowed
                      if( Object.prototype.hasOwnProperty.call(nextSource, nextKey) )
                          to[nextKey] = nextSource[nextKey];
          }

          return to;
      }
}
